import { supabase } from '../client'

export async function deleteDiscordRole(id: number) {
  const { data, error } = await supabase.from('tfProductDiscordRole').delete().match({ id })
  return { data, error }
}
